enum COLORS {
    white = '#ffffff',
    button = '#9A4C95',
    greenishBlue = '#00BCA6',
    offRed = '#FF3B3B',
    correctnessTextColor = '#1D1A31',
    titleColor = '#6E7A91',
};

export { COLORS };
